import React, { FC } from "react"
import { Caution, Paragraph, Description, Heading } from "shared/components"
import { CAUTION_SIZE, marginTop } from "shared/utils/styles"
/** @jsx jsx */
import { jsx } from "@emotion/react"
import {
  PARAGRAPHS,
  NO_GUARANTEES,
  INDEMNITY,
  USER_COVENANTS,
  LIMITATION_OF_LIABILITY_SUBLIST,
  TERM_AND_TERMINATION,
  APPLICABLE_LAW,
  NOTICES,
} from "../content/terms"
import { quote } from "shared/components/description/styles"
import { isMobile } from "shared/utils/helpers"
const TermsOfUseView: FC = () => {
  return (
    <div className="main-content-container">
      <Heading>Terms of Use</Heading>
      <div css={marginTop(20)} />
      <Description>Last updated on 29th December, 2022.</Description>
      <Paragraph>{PARAGRAPHS.PARAGRAPH_1}</Paragraph>
      <Paragraph>{PARAGRAPHS.PARAGRAPH_2}</Paragraph>
      <Paragraph>{PARAGRAPHS.PARAGRAPH_3}</Paragraph>
      <Paragraph>{PARAGRAPHS.PARAGRAPH_4}</Paragraph>
      <Paragraph>{PARAGRAPHS.PARAGRAPH_5}</Paragraph>
      <Paragraph>{PARAGRAPHS.PARAGRAPH_6}</Paragraph>
      <Paragraph>{PARAGRAPHS.PARAGRAPH_7}</Paragraph>
      <Paragraph>{PARAGRAPHS.PARAGRAPH_8}</Paragraph>
      <Paragraph>{PARAGRAPHS.PARAGRAPH_9}</Paragraph>
      <Paragraph>{PARAGRAPHS.PARAGRAPH_10}</Paragraph>
      <div css={marginTop(40)} />
      <Paragraph>
        <>
          <ol>
            <li className="heading">
              USER COVENANTS
              <div css={marginTop(40)} />
              <ol>
                {USER_COVENANTS.map((text, index) => (
                  <li key={index}>{text}</li>
                ))}
              </ol>
            </li>
            <Paragraph>{PARAGRAPHS.PARAGRAPH_11}</Paragraph>

            <div css={marginTop(40)} />
            <li className={`heading`}>
              LIMITATION OF LIABILITY
              <Paragraph>
                User specifically acknowledges and agrees that in no event shall
                We and / or Our affiliates be liable to the User or anyone
                claiming through the User in respect of any subject matter of
                this Agreement under contract, negligence, strict liability, or
                other legal or equitable theory for any special, incidental,
                indirect, punitive, exemplary, or consequential damages,
                including but not limited to, loss of profits and / or
                anticipated profits whatsoever, including those resulting from
                loss of use, data or profits, loss of opportunity, loss of
                revenues, loss of goodwill, failure to transmit or receive any
                data, loss of confidential information, business interruption,
                loss of privacy, corruption or loss of data, failure to receive
                or backup Your data (or archived data), whatsoever, including
                those resulting from loss of use, data, or profits for any cause
                of action, including contract, tort (including negligence), or
                otherwise and any other loss whatsoever, whether or not
                foreseeable or whether or not We have been advised of the
                possibility of such damages, arising out of or in connection
                with:
              </Paragraph>
              <ol>
                {LIMITATION_OF_LIABILITY_SUBLIST.map((text, index) => (
                  <li key={index}>{text}</li>
                ))}
              </ol>
              <div css={marginTop(40)} />
              <Paragraph>{PARAGRAPHS.PARAGRAPH_12}</Paragraph>
              <Paragraph>
                Notwithstanding anything to the contrary contained in this
                Agreement or elsewhere, You hereby agree that Our maximum
                aggregate liability for all Your claims under this Agreement, in
                all circumstances, shall be limited to Indian Rupees 10,000/-
                (INR Ten Thousand only).
              </Paragraph>
            </li>
            <li className="heading">
              FORCE MAJEURE
              <div css={marginTop(40)} />
              <Paragraph>
                We will not be liable for any damages whatsoever arising out of
                force majeure or other similar circumstances, directly or
                indirectly, affecting Content and / or the Platform. Examples of
                force majeure events are real or potential labour disputes,
                governmental actions, operation of law, war or threat of war,
                sabotage, civil unrest, lockdown, demonstrations, fire, storm,
                flooding, explosion, earthquake, pandemic, epidemic, provisions
                or limitations of materials or resources, inability to obtain
                the relevant authorization, accident, and defect in electricity
                or telecommunication network. Force majeure or other events
                beyond Our control hindering, delaying, or complicating the
                maintenance of the Content and / or the Platform entitles Us to
                suspend or limit the Content and / or the Platform until further
                notice.
              </Paragraph>
            </li>
            <li className="heading">
              INTELLECTUAL PROPERTY RIGHTS
              <div css={marginTop(40)} />
              <Paragraph>
                All reproduction or distribution of any material on the Content
                and / or the Platform, including but not limited to, text,
                photographs, video clips, music, and software programs is
                strictly prohibited, unless explicitly stated otherwise. We
                reserve any and all rights not expressly granted herein.
              </Paragraph>
              <Paragraph>
                Our trade name, logo, and all related trademarks, product and /
                or service names and slogans used on the Content and / or the
                Platform are Our property and may not be used in any way without
                Our prior written approval. User’s Use of the Content and / or
                the Platform shall not be construed as the grant of any license
                or right to use any trademarks or names appearing on the Content
                and / or the Platform.
              </Paragraph>
              <Paragraph>
                The information, text, graphics, images, banners, icons, logos,
                data, sounds, video clips, software codes, interface, designs,
                colour schemes and representations of the Content and / or the
                Platform, arrangement and assembly of the Content, and / or any
                of the other material or services accessible or available
                through any part of the Content and / or the Platform (together,
                “Platform Material”) are properties that belong to Us / Our
                parent company / affiliates and / or Our suppliers / vendors /
                partners, and are protected under copyright, trademark and other
                applicable laws. You shall not modify the Platform Material,
                create derivative works of, sublicense, sell, rent, lease,
                transfer, assign, time share, reproduce, display, publicly
                perform, distribute, reverse engineer, or otherwise Use the
                Platform Material, in any way for any public or commercial
                purpose or for personal gain.
              </Paragraph>
              <div css={marginTop(40)} />
              <Paragraph>{PARAGRAPHS.PARAGRAPH_13}</Paragraph>
            </li>
            <li className="heading">
              ADVERTISEMENTS
              <Paragraph>
                We may include, offer, or pormote third-party products on the
                Content and / or Platform through digital advertisements,
                whether fetched directly from advertisers and / or sourced from
                third-party advertisement 8 networks.
              </Paragraph>
              <Paragraph>
                We shall not be liable for any terms and conditions, privacy
                practices, products, services and / or the content of the
                Third-Party Platforms, advertisers, brands, or sponsors, whose
                advertisements appear on the Content and / or the Platform.
              </Paragraph>
              <Paragraph>
                The Users shall be solely responsible for checking the privacy
                policy, terms of use, and reviews of such Third-Party Platforms,
                before exploring their mobile applications, websites, and other
                internet products to safeguard their interests.
              </Paragraph>
              <Paragraph>
                If Users find any advertisement on the Content and / or the
                Platform inappropriate, unsuitable, or violative of any
                applicable law, they must immediately inform the Grievance
                Officer on the co-ordinates mentioned in Section 1.13. Upon
                receipt of such complaint, We shall try Our best to verify the
                User’s claims and, if such claims are found to be authentic, to
                restrict such advertisement from re-appearing on the Content and
                / or the Platform.
              </Paragraph>
            </li>
            <li className="heading">
              TERM AND TERMINATION
              <div css={marginTop(40)} />
              <ol>
                {TERM_AND_TERMINATION.map((text, index) => (
                  <li key={index}>{text}</li>
                ))}
              </ol>
            </li>
            <li className="heading">
              INDEMNITY
              <div css={marginTop(40)} />
              <ol>
                {INDEMNITY.map((text, index) => (
                  <li key={index}>{text}</li>
                ))}
              </ol>
            </li>
            <li className="heading">
              APPLICABLE LAW; JURISDICTION; DISPUTE RESOLUTION
              <div css={marginTop(40)} />
              <ol>
                {APPLICABLE_LAW.map((text, index) => (
                  <li key={index}>{text}</li>
                ))}
              </ol>
            </li>
            <li className="heading">
              SEVERABILITY
              <Paragraph>
                If, for any reason, a court of competent jurisdiction finds any
                provision of this Agreement, or portion thereof, to be
                unenforceable, that portion shall be enforced to the maximum
                extent permissible so as to give effect to the intent of the
                parties as reflected by that provision. The remainder of the
                Agreement shall continue in full force and effect.
              </Paragraph>
            </li>
            <div css={marginTop(40)} />
            <li className="heading">
              WAIVER
              <div css={marginTop(40)} />
              <Paragraph>
                No provision of this Agreement shall be deemed to be waived and
                no breach excused, unless such waiver or consent shall be in
                writing and signed by Us. Any consent by Us to, or a waiver by
                Us of any breach by the User, whether expressed or implied,
                shall not constitute consent to, waiver of, or excuse for any
                other different or subsequent breach.
              </Paragraph>
            </li>
            <div css={marginTop(40)} />
            <li className="heading">
              ASSIGNMENT
              <Paragraph>
                You will not transfer, assign, or delegate Your rights or
                obligations under this Agreement to anyone without Our express
                written permission. We may assign this Agreement or its rights,
                or obligations hereunder to anyone in Our sole discretion.
              </Paragraph>
            </li>
            <li className="heading">
              NOTICES
              <ol>
                {NOTICES.map((text, index) => (
                  <li key={index}>{text}</li>
                ))}
              </ol>
            </li>
          </ol>
        </>
      </Paragraph>
      <div className={`quote-wrapper ${isMobile() ? "f10" : "f14"}`}>
        <div className="separator"> </div>
        <div className="quote">
          This document is an electronic record in terms of Information
          Technology Act, 2000 of India (“<b>IT Act, 2000</b>”) and the
          applicable rules thereunder, and / or any other prevailing laws and
          the applicable rules thereunder, and the provisions pertaining to
          electronic records in various statutes as amended by the IT Act, 2000.
          This electronic record is generated by a computer system and does not
          require any physical or digital signatures.
        </div>
      </div>
    </div>
  )
}

export default TermsOfUseView
